import { TGetValueFn } from "@components/smart/FieldInfo";
import { EntitySetName } from "@odata/GeneratedEntityTypes";
import { getOData } from "@odata/OData";
import { logger } from "@utils/log";
import { memoizeOne } from "@utils/memoizeOne";

import { ODATA_API_URL } from "../../../constants";
import { IAppContext } from "../../../contexts/appContext/AppContext.types";
import { DATE_MIN, getUtcDayjs, TDateLike } from "../../../types/Date";
import { FormStorage } from "../../../views/formView/FormStorage";

/**
 * Fetches the ID of the payroll setting entity, memoize for later use.
 */
export const getPayrollSettingId = memoizeOne(async (context: IAppContext): Promise<number> => {
    let id: number;
    let exception: Error;
    const oData = await getOData(ODATA_API_URL);
    // fetch settings entity ID -> should be only one, just master entity for all PrAccountingSettings
    try {
        const query = oData.getEntitySetWrapper(EntitySetName.PrPayrollSettings).query();
        const result = await query.count().select("Id").top(1).fetchData<{ Id: number }[]>();
        id = result._metadata.count === 1 && result.value?.[0]?.Id;
    } catch (e) {
        exception = e;
    }
    if (!id) {
        logger.error("Error fetching PrPayrollSettings entity ID", exception);
    }
    return id;
}, (context) => [context.getCompanyId()]);

export function calculateStatutoryInsuranceCompanyRateDateFromLastWageDate(lastWageDate: TDateLike): TDateLike {
    if (lastWageDate && !getUtcDayjs(lastWageDate).isSame(DATE_MIN)) {
        return getUtcDayjs(lastWageDate)
            .add(1, "day")
            .subtract(1, "quarter")
            .endOf("quarter")
            .endOf("day");
    }
    return DATE_MIN;
}

export const getDecisiveDateForStatutoryInsuranceCompanyRate: TGetValueFn<TDateLike> = ({ storage }) => {
    const { lastWageDate } = (storage as FormStorage).getCustomData();
    return calculateStatutoryInsuranceCompanyRateDateFromLastWageDate(lastWageDate);
};